import { combineReducers } from 'redux';

/*
  Reducers
  Reducers match up the dispatched (fired) action with a function that should be called.
  It takes in a copy of state, modifies it, and returns the new state
  When state gets large, it makes sense to have multiple reducers that only deal with a piece of the state
*/

import { routerReducer } from 'react-router-redux'; // we need this for react-router

import commonReducer from './common';
import verificationReducer from './verification';
import mobileReducer from './mobile';
import emailReducer from './email';
import passwordReducer from './password';
import emailVerificationReducer from './emailVerification';
import authenticatorReducer from './authenticator';
import unlockReducer from './unlock';
import realinfoReducer from './realinfo';
import gameOTPReducer from './gameOTP';
import errorSecurity from './errorSecurity';
import doneSecurity from './doneSecurity';
import facebookConnect from './facebookConnect'

const rootReducer = combineReducers({
	data: commonReducer,
	verification: verificationReducer,
	password: passwordReducer,
	mobile: mobileReducer,
	email: emailReducer,
	emailVerification: emailVerificationReducer,
	authenticator: authenticatorReducer,
	unlock: unlockReducer,
	realinfo: realinfoReducer,
	gameOTP: gameOTPReducer,
	facebook: facebookConnect,
	errorSecurity: errorSecurity,
	doneSecurity: doneSecurity,
	routing: routerReducer
});

export default rootReducer;


// WEBPACK FOOTER //
// ./app/reducers/rootReducer.js